import { Node, mergeAttributes } from "@tiptap/core";
import { ReactNodeViewRenderer } from "@tiptap/react";
import { UnlockCardComponent } from "./UnlockCardComponent";

declare module '@tiptap/core' {
    interface Commands<ReturnType> {
        unlockCard: {
            setUnlockCard: (isOptimizedMode?: boolean) => ReturnType,
        }
    }
}

export const UnlockCard = Node.create({
    name: "unlockCard",
    group: "block",
    atom: true,
    draggable: false,
    selectable: false,
    content: "",

    addOptions() {
        return {
            HTMLAttributes: {},
            isOptimizedMode: false,
        };
    },

    addAttributes() {
        return {
            isOptimizedMode: {
                default: false,
                parseHTML: element => element.getAttribute('data-optimized') === 'true',
                renderHTML: attributes => ({
                    'data-optimized': attributes.isOptimizedMode,
                }),
            },
        };
    },

    parseHTML() {
        return [
            {
                tag: 'div[data-unlock-card]',
            },
        ];
    },

    renderHTML({ HTMLAttributes, node }) {
        return [
            'div',
            mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, {
                'data-unlock-card': 'true',
                'data-optimized': node.attrs.isOptimizedMode,
            }),
        ];
    },

    addNodeView() {
        return ReactNodeViewRenderer(UnlockCardComponent);
    },

    addCommands() {
        return {
            setUnlockCard:
                (isOptimizedMode = false) =>
                    ({ commands }) => {
                        return commands.insertContent({
                            type: this.name,
                            attrs: { isOptimizedMode },
                        });
                    },
        };
    },
});